import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LegalStatusView } from '@api-proxies';
import { LegalStatusService } from '@http/clients/legal-status.service';
import { EditorComponentBase, GenericDropdownComponent } from 'ngx-lib';

@Component({
    selector: 'app-legal-status-editor',
    templateUrl: './legal-status-editor.component.html',
    styleUrls: ['./legal-status-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class LegalStatusEditorComponent extends EditorComponentBase<number | null> implements OnInit {
    legalStatusItems?: LegalStatusView[];
    selectedLegalStatus?: LegalStatusView;

    constructor(private readonly legalStatusService: LegalStatusService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.legalStatusItems = await this.legalStatusService.getAll();
        if (this.bindingProperty)
            this.selectedLegalStatus = this.legalStatusItems?.find((x) => x.id === this.bindingProperty);
    }

    onLegalStatusChange() {
        if (this.selectedLegalStatus?.id) {
            this.bindingProperty = this.selectedLegalStatus.id;
        } else {
            this.bindingProperty = null;
        }
        this.valueChange.emit();
    }
}
